import { combineReducers } from "redux";
import { ACCESS_DENIED } from "./constants/auth";

import auth from "./reducers/auth";
import serverConstants from "./reducers/serverConstants";
import consultNote from "./reducers/consultNote";
import tickets from "./reducers/tickets";

const appReducer = combineReducers({
  auth,
  serverConstants,
  consultNote,
  tickets
});

const rootReducer = (_state, action) => {
  let state = _state;
  //here we will reset the whole redux state when the user access have been revoked
  if (action.type === ACCESS_DENIED) {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
